import { Component } from '@angular/core';
import { IzzyIzzyActionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Izzy Actions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyizzyaction-form',
    templateUrl: './izzyizzyaction.form.component.html'
})
export class IzzyIzzyActionFormComponent extends BaseFormComponent {
    public record!: IzzyIzzyActionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'actionDetails', sectionName: 'Action Details', isExpanded: true },
            { sectionKey: 'categorizationOrdering', sectionName: 'Categorization & Ordering', isExpanded: true },
            { sectionKey: 'accessLicensing', sectionName: 'Access & Licensing', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false },
            { sectionKey: 'izzyActionOrganizations', sectionName: 'Izzy Action Organizations', isExpanded: false }
        ]);
    }
}

